import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { units } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';
import { formatGender } from 'ha/utils/formatGender';
import { formatPreferredTenantAge } from 'ha/utils/formatPreferredTenantAge';
import { formatTenantType } from 'ha/utils/formatTenantType';
import { FacilitiesValuesTranslations } from 'ha/models/ListingFacilities/translations';

const useStyles = makeStyles()(theme => ({
  table: {
    width: '100%',
    maxWidth: '100%',
    marginBottom: units.rem(1),

    '& th, & td': {
      borderTop: 'none',
    },
    '& td': {
      lineHeight: 1.1,
      padding: units.trbl(0.5, 0, 0.5, 0),
      '&:first-of-type': {
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
          width: '35%',
        },
      },
    },
  },
}));
interface Props {
  preferredTenant: {
    minAge: number;
    maxAge: number;
    status:
      | 'any'
      | 'working'
      | 'student'
      | 'students only'
      | 'working student'
      | 'working professionals only'
      | 'looking for a job'
      | null;
    gender: string;
    couplesAllowed: string;
  };
  isCharitable?: boolean;
}

const ListingPreferredTenantSection: React.FC<Props> = ({
  preferredTenant,
  isCharitable = false,
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  const { minAge, maxAge, status, gender } = preferredTenant;
  const couplesAllowed =
    FacilitiesValuesTranslations[
      (preferredTenant.couplesAllowed || '').toLowerCase()
    ];

  return (
    <table className={classes.table}>
      <tbody>
        {!isCharitable && (
          <tr>
            <td>
              <label>{T('Age:')}</label>
            </td>
            <td data-test-locator="Preferred Tenant Age">
              {formatPreferredTenantAge(T, minAge, maxAge)}
            </td>
          </tr>
        )}
        <tr>
          <td>
            <label>{T('Gender:')}</label>
          </td>
          <td data-test-locator="Preferred Tenant Gender">
            {formatGender(T, gender)}
          </td>
        </tr>
        {!isCharitable && (
          <React.Fragment>
            <tr>
              <td>
                <label>{T('Tenant type:')}</label>
              </td>
              <td data-test-locator="Preferred Tenant Type">
                {formatTenantType(T, status)}
              </td>
            </tr>
            {couplesAllowed ? (
              <tr>
                <td>
                  <label>{T('Suitable for couples:')}</label>
                </td>
                <td data-test-locator="Preferred Tenant Couples">
                  {T(couplesAllowed)}
                </td>
              </tr>
            ) : null}
          </React.Fragment>
        )}
      </tbody>
    </table>
  );
};

export { ListingPreferredTenantSection };
